import React, { useState } from "react";
import { useSelector } from "react-redux";
import { AccessibilityHidden, AccessibilityClickableDiv, AccessibilityHiddenImg } from '@skillz/accessibility';
import { hebrewDateType } from "../../../../../../enums/hebrewDateType";
import { calendarType } from "../../../../../../enums/calendarType";
import { deviceTypes } from "../../../../../../enums/deviceTypes";
import moment from "moment";
import iconEdit from "../../../../../../../assests/icons/editFormWhite.png"
import bagrutIcon from "../../../../../../../assests/icons/bagrut.png"
import useHebrewDate from "../../../../../../hooks/useHebrewDate ";
import NavigateLink from "../../../../../features/navigateLink/navigateLink";
import useInstance from "../../../../../../hooks/useInstance";
import ClickStopper from "../../../../../ui/clickStopper/ClickStopper";
import CalendarEventCompactCard from "./calendarEventCompactCard/CalendarEventCompactCard";
import classes from './CalendarEventsByDate.module.css'

const CalendarEventsByDate = ({ dateKey, events, currentChooseDate, nearestEvent, newStyle }) => {

    const { texts } = useSelector(state => state.translate);
    const deviceType = useSelector(state => state.responsive.deviceType);
    const [showPopup, setShowPopup] = useState(null)
    const instance = useInstance()
    const hebrewDate = useHebrewDate();

    const generate = (event) => {

        const style = {
            borderColor: event.holiday ? "#53C8E1" : event.domainColor,
            background: (event.Domain === "holidays" || event.isAssessment) ? `${event.domainColor}33` : event.holiday ? "#53C8E133" : !event.IsAllDay && "#E3E1E1"
        };
        const className = `${classes.Event} ${event.isAssessment ? classes.Assessment : !event.link ? classes.hiddenPointer : ''}`;

        return <div className={`${classes.WrapEvent} ${(event.Id === nearestEvent?.Id && event.date === nearestEvent?.date) ? classes.NearestEvent : null}`}>
            {(deviceType !== deviceTypes.mobile && event.hiddenPopup) ?
                <div className={className} style={style}>{generateContent(event)}</div> :
                <AccessibilityClickableDiv className={className} style={style} onClick={() => setShowPopup(`${event.externalId}${event.date}`)}>{generateContent(event)}</AccessibilityClickableDiv>
            }
        </div >
    }

    const generateContent = (event) => {
        return <>
            <div className={classes.RightPart}>
                <div className={classes.Content}>
                    {!event.allDayEvent &&
                        <p className={classes.Time}>{`
                        ${event.to && moment(new Date(event.to)).format("HH:mm")} - 
                        ${event.from && moment(new Date(event.from)).format("HH:mm")} `} </p>}
                    <div className={classes.contentWrap}>
                        {event.bagrut && <AccessibilityHiddenImg className={classes.EditIcon} src={bagrutIcon} />}
                        {event.isAssessment && <AccessibilityHiddenImg className={classes.EditIcon} src={iconEdit} />}
                        <div className={classes.TextEditEvent}>
                            {event.isAssessment && <p className={classes.AssessmentSGName}>{event.description}</p>}
                            <p className={classes.EventText}>{event.bagrut ? (texts.matriculationIn ?? "") + event.title : event.title}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={classes.LeftPart}>
                <div>
                    {!event.allDayEvent && new Date() >= new Date(event.to) && new Date() <= new Date(event.from) &&
                        <div className={classes.Live}>
                            <p>LIVE</p>
                            <p className={classes.Arrows}>
                                <AccessibilityHidden>{">>"}</AccessibilityHidden>
                            </p>
                        </div>}
                </div>
            </div>
        </>
    }

    const renderContent = (event) => {
        return <>
            {(nearestEvent && event.Id === nearestEvent?.Id && event.date === nearestEvent?.date) && <p className={classes.UpcomingEvents}>{texts.upcomingEvent}:</p>}
            {generate(event)}
            {/* {event.hiddenPopup ? (generate(event)) : (<MyTooltipComponent offsetY={-10} offsetX={200} style={{ height: '100%' }} Content={() => <CalendarEventPopup {...event} calendarType="FullCalendar" />}>{generate(event)}</MyTooltipComponent>)} */}
        </>
    }

    return (
        <div className={classes.EventsByDate}>
            {!newStyle &&
                <p className={`${classes.Date} ${new Date(dateKey).toDateString() === new Date(currentChooseDate).toDateString() ? `${classes.Today}` : ''}`}>
                    <span className={classes.TodayText}>{texts.today},</span>
                    {window.config.calendarMode === calendarType.jewish ?
                        `${instance.formatDate(new Date(dateKey), { format: 'EE, ' })} ${hebrewDate(new Date(dateKey), hebrewDateType.day)} ${hebrewDate(new Date(dateKey), hebrewDateType.month)}`
                        :
                        `${instance.formatDate(new Date(dateKey), { format: 'EE, dd MMMM' })}`
                    }
                </p>
            }

            <div className={classes.Events}>
                {events?.map((event, index) =>
                    deviceType !== deviceTypes.mobile ?
                        event.link ?
                            <ClickStopper key={index}>
                                <NavigateLink link={event.link} key={index}>
                                    {renderContent(event)}
                                </NavigateLink>
                            </ClickStopper>

                            :
                            <div key={index}>
                                {renderContent(event)}
                            </div>
                        :
                        <>
                            {!newStyle && (event.Id === nearestEvent?.Id && event.date === nearestEvent?.date) && <p className={classes.UpcomingEvents}>{texts.upcomingEvent}</p>}
                            {newStyle ?
                                <AccessibilityClickableDiv
                                    key={index}
                                    className={classes.CompactEventWrap}
                                    onClick={() => setShowPopup(`${event.externalId}${event.date}`)}
                                >
                                    <CalendarEventCompactCard event={event} />
                                </AccessibilityClickableDiv>
                                :
                                generate(event)
                            }
                            {/* {showPopup === `${event.externalId}${event.date}` &&
                                <NavigatePopupMobile clickHandle={() => setShowPopup(null)} name={texts.event}>
                                    <CalendarEventPopup
                                        Domain={event.domin}
                                        DomainColor={event.domainColor}
                                        Picture={event.picture}
                                        Id={event.courseExternalId} tags={event.tags}
                                        Subject={event.title}
                                        Description={event.description}
                                        ProviderDescription={event.providerDescription}
                                        StartTime={new Date(event.from || event.date)}
                                        IsAllDay={event.allDayEvent}
                                        EndTime={new Date(event.to)}
                                        Teachers={event.teachers}
                                        Link={event.link}
                                        ProviderLogo={event.providerLogo}
                                        isAssessment={event.isAssessment}
                                        Holiday={event.holiday}
                                        bagrut={event.bagrut}
                                        calendarType={"CalendarTab"} />
                                </NavigatePopupMobile>} */}
                        </>
                )}
            </div>

        </div >
    )
}

export default CalendarEventsByDate
